// extracted by mini-css-extract-plugin
export default {"container":"OrdersAdmin_container__yLaQk","CardTop":"OrdersAdmin_CardTop__IvNNZ","Card":"OrdersAdmin_Card__oYCQ1","cardbtn":"OrdersAdmin_cardbtn__rHauO"};